import React from "react";
import styled from "styled-components";
import Tile from "../components/map/MapTile";
import { mapConfig } from "../utils/map-utils/map-config";

interface IMapTile {
  count: number;
  width: number;
  height: number;
  coords: {
    x: number;
    y: number;
  };
}

const TileMap: React.FC<{ type: string }> = React.memo((props) => {
  const [boxes, setBoxes] = React.useState<IMapTile[]>([]);

  React.useEffect(() => {
    // get dimensions of boxes
    const boxWidth = mapConfig.width / mapConfig.tiles.x;
    const boxHeight = mapConfig.height / mapConfig.tiles.y;

    const allCoords: IMapTile[] = [];
    let count = 0;
    // calculate coordinates of all boxes
    for (let yindex = 0; yindex < mapConfig.tiles.y; yindex++) {
      for (let xindex = 0; xindex < mapConfig.tiles.x; xindex++) {
        count++;
        allCoords.push({
          count,
          width: boxWidth,
          height: boxHeight,
          coords: {
            x: boxWidth * (xindex + 1) - boxWidth - mapConfig.width / 2,
            y: boxHeight * (yindex + 1) - boxHeight - mapConfig.height / 2,
          },
        });
      }
    }
    setBoxes(allCoords);
  }, []);

  return (
    <TileContainer
      style={{
        height: `${mapConfig.height}px`,
        width: `${mapConfig.width}px`,
        transform: `translate(${-(mapConfig.width / 2)}px, ${-(
          mapConfig.height / 2
        )}px)`,
      }}
    >
      <Tiles>
        {boxes &&
          boxes.map((box, i) => {
            return (
              <Tile
                path={props.type}
                key={i}
                count={box.count}
                style={{
                  transform: `translate(${box.coords.x}px, ${box.coords.y}px)`,
                  width: box.width,
                  height: box.height,
                }}
              />
            );
          })}
      </Tiles>
    </TileContainer>
  );
});

const Tiles = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;

const TileContainer = styled.div`
  position: absolute;
`;

export default TileMap;
